import { render, staticRenderFns } from "./ChangeCourseType.vue?vue&type=template&id=ea8d1586&scoped=true&"
import script from "./ChangeCourseType.vue?vue&type=script&lang=js&"
export * from "./ChangeCourseType.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCourseType.vue?vue&type=style&index=0&id=ea8d1586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8d1586",
  null
  
)

export default component.exports